import LinkCTA from '2-core-elements/LinkCTA/LinkCTA';
import DataList from '6-my-mcc/Components/DataList/DataList';
import { useState, type FC } from 'react';
import FormRenewalNotice from './FormRenewalNotice';
import type { CommunicationPreferencesFormType } from '../../Utils/useCommunicationPreferencesConfig';
import { pushGTMEvent } from 'utils/eventGTM';

type FormRenewalNoticeProps = {
    renewalNoticeConfig?: CommunicationPreferencesFormType ;
    value: string | null;
    isWaitingListMember: boolean | null;
}

const RenewalNotice: FC<FormRenewalNoticeProps> = ({ renewalNoticeConfig, value, isWaitingListMember }) => {
    const [showEditForm, setShowEditForm] = useState<boolean>(false);

    if (isWaitingListMember) {
        return null;
    }

    return (
        <div className="communication-preferences-panel">
            <div className="communication-preferences-panel-header base-wrapper-header">
                <h2 className="base-wrapper-title">Renewal Notice</h2>
                <div className="communication-preferences-panel-tools">
                    {showEditForm ? (
                        <LinkCTA
                            size={'sm'}
                            prefixIcon={'close'}
                            aria-label="Cancel edit"
                            type="button"
                            onClick={(): void => {
                                setShowEditForm(false);
                            }}
                            onlyIcon={true}
                        />
                    ) : (
                        <LinkCTA
                            size={'xs'}
                            suffixIcon={'edit'}
                            aria-label="Edit renewal notice preference"
                            type="button"
                            onClick={(): void => {
                                setShowEditForm(true);
                            }}
                        >
                            Edit
                        </LinkCTA>
                    )}
                </div>
            </div>

            {showEditForm && renewalNoticeConfig && (
                <FormRenewalNotice
                    renewalNoticeConfig={renewalNoticeConfig}
                    value={value}
                    onSubmitSuccess={(): void => {
                        setShowEditForm(false);

                        pushGTMEvent({
                            actionType: 'form_complete',
                            name: 'Renewal notice',
                            type: 'Communication preferences',
                        });
                    }}
                />
            )}

            {!showEditForm && renewalNoticeConfig && (
                <DataList>
                    <DataList.Item
                        label={renewalNoticeConfig.name}
                        value={value === 'HardCopy' ? 'Hard Copy' : value || ''}
                    />
                </DataList>
            )}
        </div>
    );
};

export default RenewalNotice;
